import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "report-responses" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Responses ")
const _hoisted_3 = { class: "report-responses__headings d-none d-md-flex row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "Alarm Level:", -1)
const _hoisted_5 = { class: "cell col-8 col-md-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "CallSign:", -1)
const _hoisted_7 = { class: "cell col-8 col-md-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "Dispatched:", -1)
const _hoisted_9 = { class: "cell col-8 col-md-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "Responded:", -1)
const _hoisted_11 = { class: "cell col-8 col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "Arrived:", -1)
const _hoisted_13 = { class: "cell col-8 col-md-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "cell heading col-4 d-md-none" }, "Departed:", -1)
const _hoisted_15 = { class: "cell col-8 col-md-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportSectionHeader = _resolveComponent("ReportSectionHeader")!
  const _component_GenericTableHeaderButton = _resolveComponent("GenericTableHeaderButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReportSectionHeader, {
      onFilterToggled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAccordion())),
      isOpen: _ctx.isOpen
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createElementVNode("div", {
      class: _normalizeClass(["report-responses__content-container", { open: _ctx.isOpen }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GenericTableHeaderButton, {
          class: "alarm-level col-2",
          label: "Alarm Level",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "callsign col-2",
          label: "CallSign",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "dispatched col-2",
          label: "Dispatched",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "responded col-2",
          label: "Responded",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "arrived col-2",
          label: "Arrived",
          sortable: false
        }),
        _createVNode(_component_GenericTableHeaderButton, {
          class: "departed col-2",
          label: "Departed",
          sortable: false
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportStore.report.cadEventDeployedResponseResults, (response) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "report-responses__data row",
          key: response.responseIdentifier
        }, [
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(response.dispatchedAlarmLevelNumber), 1),
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(response.callSignCode), 1),
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.formatDayMonthTime(response.dispatchedTimestamp) ?? "-"), 1),
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDayMonthTime(response.responseTimestamp) ?? "-"), 1),
          _hoisted_12,
          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.formatDayMonthTime(response.turnoutTimestamp) ?? "-"), 1),
          _hoisted_14,
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.formatDayMonthTime(response.departedTimestamp) ?? "-"), 1)
        ]))
      }), 128))
    ], 2)
  ]))
}